var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRequirementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.173,
    height: 19.173,
    viewBox: "0 0 19.173 19.173",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58265",
    "data-name": "Group 58265",
    transform: "translate(-884.75 -631.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_58264",
    "data-name": "Group 58264",
    transform: "translate(885 632)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42185",
    "data-name": "Path 42185",
    d: "M17.852,7.932a.822.822,0,0,0-.774.547H15.518V8.16a.274.274,0,1,0-.547,0V9.494a5.538,5.538,0,0,1-1.288,3.617,10.885,10.885,0,0,1-4.347,3.055,10.947,10.947,0,0,1-3.972-2.64.274.274,0,0,0-.4.377A11.176,11.176,0,0,0,6.182,15v2.078a.821.821,0,1,0,.547,0V15.4a11.907,11.907,0,0,0,2.455,1.292.422.422,0,0,0,.3,0,11.433,11.433,0,0,0,4.61-3.227,5.865,5.865,0,0,0,1.208-2.325h.925a.821.821,0,1,0,0-.547h-.806a6.517,6.517,0,0,0,.093-1.1V9.026h1.561a.821.821,0,1,0,.774-1.094ZM6.455,18.126a.274.274,0,1,1,.274-.274A.274.274,0,0,1,6.455,18.126ZM17,10.595a.274.274,0,1,1-.274.274A.274.274,0,0,1,17,10.595Zm.848-1.568a.274.274,0,1,1,.274-.274A.274.274,0,0,1,17.852,9.026ZM3.7,9.494V4.518A10.938,10.938,0,0,0,6.8,3.2a4.9,4.9,0,0,1,5.069,0,12.7,12.7,0,0,0,1.4.732l.016.007a9.694,9.694,0,0,0,1.687.576V6.99a.274.274,0,1,0,.547,0V4.417a.418.418,0,0,0-.321-.409,8.926,8.926,0,0,1-1.539-.5V1.594a.821.821,0,1,0-.547,0V3.258q-.475-.233-.958-.524a5.443,5.443,0,0,0-5.634,0A10.3,10.3,0,0,1,3.475,4.008a.418.418,0,0,0-.321.409V6.072H1.594a.821.821,0,1,0,0,.547H3.155V8.188H2.442a.821.821,0,1,0,0,.547h.713v.759A6.124,6.124,0,0,0,4.25,13.049a.274.274,0,1,0,.447-.315A5.58,5.58,0,0,1,3.7,9.494ZM13.385.547a.274.274,0,1,1-.274.274A.274.274,0,0,1,13.385.547ZM.821,6.619a.274.274,0,1,1,.274-.274A.274.274,0,0,1,.821,6.619Zm.848,2.115a.274.274,0,1,1,.274-.274A.274.274,0,0,1,1.669,8.735Zm0,0",
    transform: "translate(0 0)",
    fill: "#d31bb9",
    stroke: "#d31bb9",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_42131_-_Outline",
    "data-name": "Path 42131 - Outline",
    d: "M9.8,6.6a.593.593,0,0,1,.42,1.012L7.691,10.141a.588.588,0,0,1-.42.17.581.581,0,0,1-.414-.17L5.588,8.877a.594.594,0,0,1,.839-.84l.844.844L9.385,6.768A.589.589,0,0,1,9.8,6.6Z",
    transform: "translate(886.431 632.549)",
    fill: "#d31aba"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequirementIcon);
export default __webpack_public_path__ + "static/media/RequirementIcon.9a6a96a8eac0053dd001bd87668ef402.svg";
export { ForwardRef as ReactComponent };